import { Button, Col, Drawer, Typography } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { rulesSushiLunchService } from "../../../shared/services";
import { useNavigate } from "react-router-dom";
import { IRulesSushiLunch } from "../../../redux/@types/rulesSushiLunch";
import { useUpdateStatusRulesSushiLunch } from "../hooks/useUpdateStatusRulesSushiLunch";
import React from "react";
import { useRemoveRulesSushiLunch } from "../hooks/useRemoveRulesSushiLunch";
import { EditRulesSushiLunchForm } from "./form";

const { Title, Text } = Typography;

export const TableRulesSushiLunch = () => {
  const { showDeleteConfirm, setTableProps } = useRemoveRulesSushiLunch();
  const { updateStatus, isLoading } = useUpdateStatusRulesSushiLunch();
  const [openModalEditRule, setOpenModalEditRule] = React.useState<boolean>();
  const [ruleId, setRuleId] = React.useState<number>();
  const navigate = useNavigate();

  const handleNavigateDetail = (rule_id: number) => {
    navigate(`/sushi-lunch-products/${rule_id}`);
  };

  const handleOpenEdit = (rule_id: number) => {
    setRuleId(rule_id);
    setOpenModalEditRule(true);
  };

  const columns: TableColumns<IRulesSushiLunch> = [
    {
      title: "Nombre",
      width: 7,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                updateStatus(
                  item.status === "active" ? "inactive" : "active",
                  item.id
                );
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Días",
      width: 10,
      key: "days",
      render: (_, item) => {
        const days: string[] = [];
        if (item.monday === "true") days.push("Lun");
        if (item.tuesday === "true") days.push("Mar");
        if (item.wednesday === "true") days.push("Mié");
        if (item.thursday === "true") days.push("Jue");
        if (item.friday === "true") days.push("Vie");
        if (item.saturday === "true") days.push("Sáb");
        if (item.sunday === "true") days.push("Dom");
        return <Text>{days.join(", ") || "Ninguno"}</Text>;
      },
    },
    {
      title: "Aplica a",
      width: 4,
      dataIndex: "apply_to",
      key: "apply_to",
    },
    {
      title: "Hora inicio",
      width: 4,
      dataIndex: "start_time",
      key: "start_time",
    },
    {
      title: "Hora fin",
      width: 4,
      dataIndex: "end_time",
      key: "end_time",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 10,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={() => handleNavigateDetail(item.id)}
              type="primary"
              shape="circle"
              icon={<EyeOutlined />}
              size="large"
            />
            <Button
              onClick={() => handleOpenEdit(item.id)}
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              onClick={() => showDeleteConfirm(item.id, item.name)}
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <Table<IRulesSushiLunch>
        columns={columns}
        fetchQueryProps={{ $sort: { id: -1 } }}
        service={rulesSushiLunchService}
        onLoad={setTableProps}
      />
      <Drawer
        title={`Editar regla`}
        open={openModalEditRule}
        width={"320px"}
        destroyOnClose
        onClose={() => setOpenModalEditRule(false)}
      >
        {ruleId && (
          <EditRulesSushiLunchForm
            setOpenModalEditRule={setOpenModalEditRule}
            ruleId={ruleId}
          />
        )}
      </Drawer>
    </>
  );
};
